// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"9MIHx":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Checkmark);
var _jsxRuntime = require("react/jsx-runtime");
var _s2FillCheckmarkGeneric1160Svg = require("illustration:./S2_fill_checkmark_generic1_160.svg");
var _s2FillCheckmarkGeneric1160SvgDefault = parcelHelpers.interopDefault(_s2FillCheckmarkGeneric1160Svg);
var _s2FillCheckmarkGeneric196Svg = require("illustration:./S2_fill_checkmark_generic1_96.svg");
var _s2FillCheckmarkGeneric196SvgDefault = parcelHelpers.interopDefault(_s2FillCheckmarkGeneric196Svg);
var _s2FillCheckmarkGeneric148Svg = require("illustration:./S2_fill_checkmark_generic1_48.svg");
var _s2FillCheckmarkGeneric148SvgDefault = parcelHelpers.interopDefault(_s2FillCheckmarkGeneric148Svg);
var _icon = require("../../../src/Icon");
var _reactAriaComponents = require("react-aria-components");
function Checkmark(props) {
    [props] = (0, _reactAriaComponents.useContextProps)(props, null, (0, _icon.IllustrationContext));
    let { size = 'M', ...otherProps } = props;
    switch(size){
        case 'L':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillCheckmarkGeneric1160SvgDefault.default), {
                ...otherProps
            });
        case 'S':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillCheckmarkGeneric148SvgDefault.default), {
                ...otherProps
            });
        case 'M':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2FillCheckmarkGeneric196SvgDefault.default), {
                ...otherProps
            });
    }
}

},{"react/jsx-runtime":"2Is6Z","illustration:./S2_fill_checkmark_generic1_160.svg":"ivfC7","illustration:./S2_fill_checkmark_generic1_96.svg":"hv4iJ","illustration:./S2_fill_checkmark_generic1_48.svg":"04ByG","../../../src/Icon":"jQAJE","react-aria-components":"bA6Cz","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"ivfC7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 160,
        height: 160,
        viewBox: "0 0 160 160",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "aaa33d__d",
                        x1: -24.021,
                        x2: 201.071,
                        y1: 134.5,
                        y2: -2.444,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "aaa33d__e",
                        x1: 156.616,
                        x2: 60.052,
                        y1: 36.277,
                        y2: 140.11,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "aaa33d__f",
                        x1: 39.265,
                        x2: 210.447,
                        y1: 154.441,
                        y2: 58.547,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "aaa33d__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 36.455 52.6)scale(60.2331)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "aaa33d__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 52.682 88.47)scale(60.2331)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "aaa33d__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 138.449,
                            height: 138.449,
                            x: 10.773,
                            y: 10.775,
                            fill: "#fff",
                            rx: 3.461
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "aaa33d__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    d: "M80 28c-28.719 0-52 23.281-52 52s23.281 52 52 52 52-23.281 52-52-23.281-52-52-52m20.691 42.83L76.692 94.83c-.75.75-1.767 1.171-2.828 1.171h-.022c-1.07-.006-2.091-.44-2.838-1.204l-11.729-12c-1.544-1.58-1.515-4.112.065-5.657 1.58-1.543 4.112-1.515 5.656.065l8.9 9.107L95.038 65.17c1.565-1.56 4.097-1.56 5.657.003 1.562 1.563 1.56 4.096-.003 5.657"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#aaa33d__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#aaa33d__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 138.449,
                            height: 138.449,
                            x: 10.773,
                            y: 10.775,
                            fill: "#FFECCF",
                            rx: 3.461
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M10.773 10.775h138.45v138.45H10.772z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 89.055,
                            cy: 16.146,
                            r: 60.233,
                            fill: "url(#aaa33d__c)",
                            transform: "rotate(-.08 89.055 16.146)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#aaa33d__d)",
                            d: "M63.616-13.68c-10.633-6.58-24.104-6.62-34.777-.105L-77.903 51.39c-10.454 6.383-10.471 21.45-.031 27.856l106.037 65.081c10.656 6.54 24.127 6.532 34.775-.023l105.818-65.142c10.385-6.393 10.404-21.376.032-27.793z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#aaa33d__e)",
                            d: "M30.726 76.508c2.366-51.688 46.185-91.67 97.872-89.304 51.688 2.367 91.67 46.186 89.304 97.873-2.367 51.687-46.186 91.67-97.873 89.303-51.687-2.366-91.67-46.185-89.303-97.872"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#aaa33d__f)",
                            d: "M-45.32 110.588c20.546-8.765 42.705-8.389 61.902-.723 38.415 15.38 60.767 5.871 76.27-32.455 7.722-19.233 22.799-35.52 43.368-44.295 41.124-17.517 88.601 1.49 106.093 42.493s-1.654 88.404-42.769 105.944c-20.615 8.794-42.816 8.382-62.042.647-38.353-15.297-60.662-5.753-76.146 32.62-7.742 19.186-22.815 35.418-43.36 44.183-41.092 17.53-88.568-1.477-106.05-42.457-17.483-40.98 1.643-88.427 42.735-105.957"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 141.153,
                            cy: 35.788,
                            r: 60.233,
                            fill: "url(#aaa33d__g)",
                            transform: "rotate(-.08 141.153 35.788)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"hv4iJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 96,
        height: 96,
        viewBox: "0 0 96 96",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "cd89ac__d",
                        x1: -14.409,
                        x2: 120.646,
                        y1: 80.7,
                        y2: -1.467,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "cd89ac__e",
                        x1: 93.971,
                        x2: 36.033,
                        y1: 21.766,
                        y2: 84.066,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "cd89ac__f",
                        x1: 23.561,
                        x2: 126.271,
                        y1: 92.664,
                        y2: 35.128,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "cd89ac__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 21.875 31.562)scale(36.1398)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "cd89ac__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 31.611 53.083)scale(36.1398)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "cd89ac__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 83.07,
                            height: 83.07,
                            x: 6.465,
                            y: 6.465,
                            fill: "#fff",
                            rx: 2.077
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "cd89ac__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    d: "M48 16.8c-17.23 0-31.2 13.968-31.2 31.2S30.77 79.2 48 79.2c17.232 0 31.2-13.969 31.2-31.2S65.233 16.8 48 16.8m12.416 25.698-14.4 14.399c-.45.45-1.06.703-1.697.703h-.013c-.642-.004-1.255-.264-1.703-.723l-7.037-7.2c-.926-.948-.91-2.467.039-3.394.948-.926 2.467-.909 3.393.04l5.34 5.463 12.685-12.684c.939-.937 2.458-.936 3.394.002.937.938.936 2.457-.001 3.394"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#cd89ac__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#cd89ac__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 83.07,
                            height: 83.07,
                            x: 6.465,
                            y: 6.465,
                            fill: "#FFECCF",
                            rx: 2.077
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M6.465 6.465h83.07v83.07H6.465z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 53.436,
                            cy: 9.687,
                            r: 36.14,
                            fill: "url(#cd89ac__c)",
                            transform: "rotate(-.08 53.436 9.687)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#cd89ac__d)",
                            d: "M38.173-8.209c-6.38-3.947-14.463-3.972-20.866-.062L-46.74 30.833c-6.272 3.83-6.283 12.87-.019 16.714l63.623 39.048c6.393 3.924 14.477 3.92 20.865-.014l63.491-39.085c6.231-3.836 6.242-12.825.019-16.676z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#cd89ac__e)",
                            d: "M18.437 45.905c1.42-31.013 27.711-55.002 58.724-53.582s55.001 27.711 53.582 58.723c-1.42 31.013-27.712 55.002-58.724 53.582-31.012-1.419-55.002-27.71-53.582-58.723"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#cd89ac__f)",
                            d: "M-27.19 66.352c12.328-5.259 25.623-5.033 37.142-.433C33 75.146 46.412 69.44 55.714 46.445c4.633-11.539 13.679-21.312 26.02-26.576 24.675-10.51 53.161.893 63.656 25.495s-.992 53.043-25.661 63.567c-12.369 5.276-25.69 5.029-37.226.388-23.011-9.178-36.397-3.452-45.687 19.572-4.645 11.512-13.689 21.251-26.016 26.51-24.655 10.518-53.141-.886-63.63-25.474s.986-53.057 25.64-63.575"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 84.694,
                            cy: 21.472,
                            r: 36.14,
                            fill: "url(#cd89ac__g)",
                            transform: "rotate(-.08 84.694 21.472)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"04ByG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "04d9bd__d",
                        x1: -7.203,
                        x2: 60.325,
                        y1: 40.349,
                        y2: -0.734,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.06,
                                stopColor: "#8480FE"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.6,
                                stopColor: "#8480FE",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "04d9bd__e",
                        x1: 46.986,
                        x2: 18.016,
                        y1: 10.883,
                        y2: 42.033,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "04d9bd__f",
                        x1: 11.783,
                        x2: 63.137,
                        y1: 46.333,
                        y2: 17.564,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.432,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.609,
                                stopColor: "#FC7D00"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FC7D00",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "04d9bd__c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 10.938 15.782)scale(18.0699)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#FF709F"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF709F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "04d9bd__g",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "rotate(90 15.806 26.543)scale(18.0699)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.167,
                                stopColor: "#EB1000"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EB1000",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "04d9bd__b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 41.535,
                            height: 41.535,
                            x: 3.234,
                            y: 3.232,
                            fill: "#fff",
                            rx: 1.038
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: "04d9bd__a",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    d: "M23.998 8.4c-8.615 0-15.6 6.985-15.6 15.6 0 8.616 6.985 15.6 15.6 15.6 8.616 0 15.6-6.984 15.6-15.6s-6.984-15.6-15.6-15.6m6.208 12.85-7.2 7.199c-.225.225-.53.351-.848.351h-.007c-.32-.002-.627-.132-.851-.36l-3.519-3.6c-.463-.475-.455-1.235.02-1.698.473-.463 1.233-.454 1.696.02l2.67 2.732 6.343-6.343c.469-.468 1.229-.467 1.697.001.468.47.468 1.23-.001 1.697"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#04d9bd__a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#04d9bd__b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 41.535,
                            height: 41.535,
                            x: 3.234,
                            y: 3.232,
                            fill: "#FFECCF",
                            rx: 1.038
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFECCF",
                            d: "M3.234 3.232H44.77v41.535H3.234z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 26.72,
                            cy: 4.843,
                            r: 18.07,
                            fill: "url(#04d9bd__c)",
                            transform: "rotate(-.08 26.72 4.843)"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#04d9bd__d)",
                            d: "M19.088-4.105c-3.19-1.974-7.231-1.986-10.433-.031l-32.022 19.552c-3.137 1.915-3.142 6.435-.01 8.357L8.434 43.297c3.197 1.962 7.239 1.96 10.433-.007l31.745-19.542c3.116-1.918 3.121-6.413.01-8.338z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#04d9bd__e)",
                            d: "M9.219 22.952c.71-15.506 13.855-27.5 29.361-26.79s27.501 13.855 26.791 29.361S51.516 53.024 36.01 52.314 8.509 38.46 9.219 22.952"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "url(#04d9bd__f)",
                            d: "M-13.593 33.177c6.164-2.63 12.812-2.517 18.57-.217 11.525 4.614 18.23 1.761 22.882-9.737 2.316-5.77 6.84-10.656 13.01-13.288 12.337-5.255 26.58.447 31.828 12.748s-.496 26.52-12.83 31.783c-6.185 2.638-12.845 2.515-18.613.194-11.506-4.59-18.199-1.726-22.844 9.786C16.087 70.202 11.566 75.07 5.402 77.7c-12.328 5.259-26.57-.443-31.815-12.737s.493-26.528 12.82-31.787"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: 42.349,
                            cy: 10.736,
                            r: 18.07,
                            fill: "url(#04d9bd__g)",
                            transform: "rotate(-.08 42.35 10.736)"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIllustration)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}]},[], null, "parcelRequire7f0c", {})

//# sourceMappingURL=Dialog.99b03a98.js.map
